import React, { useState, useEffect, useMemo } from 'react'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { collegeColumns } from '../../Data/CollegeManagement/CollegeListData'
import { getAllData, deleteIdData } from '../../lib/collegerank'
import { useDataManagement } from '../../Hooks/useDataManagement'
import CollegeModal from './CollegeModal'

const InstructorCollegeList = () => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editingCollege, setEditingCollege] = useState(null)
	const [isDarkMode, setIsDarkMode] = useState(false)

	const { data: colleges, loading, searchQuery, setSearchQuery, handleDelete, fetchData } = useDataManagement(getAllData, deleteIdData)

	useEffect(() => {
		const checkDarkMode = () => {
			setIsDarkMode(document.body.classList.contains('dark-only'))
		}
		checkDarkMode()
		const observer = new MutationObserver(checkDarkMode)
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
		return () => observer.disconnect()
	}, [])

	const sortedColleges = useMemo(() => {
		return [...colleges].sort((a, b) => {
			const nameA = a.collegename ? a.collegename : ''
			const nameB = b.collegename ? b.collegename : ''
			return nameA.localeCompare(nameB)
		})
	}, [colleges])

	const handleEdit = (college) => {
		setEditingCollege(college)
		setIsModalOpen(true)
	}

	const handleAdd = () => {
		setEditingCollege(null)
		setIsModalOpen(true)
	}

	const toggleModal = () => {
		setIsModalOpen(!isModalOpen)
	}

	return (
		<>
			<DataManagementGrid
				title="College List"
				subTitle="Manage all desired colleges"
				breadcrumbTitle="College Management"
				breadcrumbMainTitle="College Management"
				columns={(layout, role) => collegeColumns(layout, role, handleEdit)}
				data={sortedColleges}
				loading={loading}
				searchQuery={searchQuery}
				setSearchQuery={setSearchQuery}
				searchPlaceholder="Search by college name..."
				createButtonText="Add New College"
				additionalActionButton={
					<button onClick={handleAdd} className="btn btn-primary">
						<i className="fa fa-plus me-2"></i>
						Add New College
					</button>
				}
				onDelete={handleDelete}
				searchFields={['collegename']}
				noDataMessage="No colleges found"
			/>
			<CollegeModal
				isOpen={isModalOpen}
				toggle={toggleModal}
				editingCollege={editingCollege}
				onSave={fetchData}
				isDarkMode={isDarkMode}
			/>
		</>
	)
}

export { InstructorCollegeList }
